import { useEffect, useMemo, useState } from "react";
import { CartTimerResult, getReservationTimer } from "../utils/cartTimer";

const TIMER_INTERVAL_MS = 1000;

export const useCartTimer = (
    expiresAt: string | undefined,
): CartTimerResult => {
    const [timerTick, setTimerTick] = useState(0);

    useEffect(() => {
        if (!expiresAt) {
            return;
        }

        const interval = setInterval(() => {
            setTimerTick((value) => value + 1);
        }, TIMER_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [expiresAt]);

    return useMemo(() => {
        void timerTick;
        return getReservationTimer(expiresAt);
    }, [expiresAt, timerTick]);
};
